// Fades hob sections in once as they scroll into view.
// Elements are only hidden after this script runs, so content stays visible if it never loads.
// Anything already on screen, the theme editor and reduced motion are all left alone.

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const designMode = Boolean(window.Shopify?.designMode);

if (!reducedMotion && !designMode && 'IntersectionObserver' in window) {
  /** @type {Set<HTMLElement>} */
  const pending = new Set();

  /** @param {HTMLElement} element */
  const show = (element) => {
    element.dataset.hobReveal = 'shown';
    pending.delete(element);
    observer.unobserve(element);
    if (!pending.size) document.removeEventListener('scroll', onScroll, { capture: true });
  };

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting && entry.target instanceof HTMLElement) show(entry.target);
      }
    },
    { rootMargin: '0px 0px -8% 0px' }
  );

  // Backstop for sections passed in one jump (a fling, an anchor, a restored scroll position),
  // which the observer never sees intersect. Capture catches scrolling in any container, such as
  // the theme's page wrapper on wide screens.
  let frame = 0;
  function onScroll() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      for (const element of pending) {
        if (element.getBoundingClientRect().top < window.innerHeight * 0.92) show(element);
      }
    });
  }

  for (const element of document.querySelectorAll('[data-hob-reveal=""]')) {
    if (!(element instanceof HTMLElement)) continue;
    if (element.getBoundingClientRect().top < window.innerHeight) continue;

    element.dataset.hobReveal = 'hidden';
    pending.add(element);
    observer.observe(element);
  }

  if (pending.size) document.addEventListener('scroll', onScroll, { capture: true, passive: true });
}
